// extracted by mini-css-extract-plugin
module.exports = {"row":"ReplacedExpenditure_row__1DkMH","container":"ReplacedExpenditure_container__qCM7z","btn":"ReplacedExpenditure_btn__3frHG"};